
import { Component, Vue } from "vue-property-decorator"
import {
  ConsultantInvoice,
  FinanceStatisticsQuery,
  FinanceStatisticsQueryQuery,
  MissionLifecycleSelectQuery,
  InvoicesListQuery,
  ConsultantInvoiceStateEnum,
} from "@/gql"
import AppPage from "@/components/layout/AppPage.vue"
import Table from "@/components/widgets/data/Table.vue"
import { FetchResult } from "apollo-link"

@Component({ components: { Table, AppPage } })
export default class Invoices extends Vue {
  statsQuery = FinanceStatisticsQuery
  readonly missionLifecycleSelectQuery = MissionLifecycleSelectQuery
  readonly consultantInvoiceState = ConsultantInvoiceStateEnum

  headers = [
    {
      text: "Consultant",
      value: "consultant",
      custom: true,
      sortable: false,
    },
    {
      text: "Mission",
      value: "mission",
      custom: true,
      sortable: false,
    },
    {
      text: "Invoice Number",
      value: "invoiceNumber",
      custom: true,
    },
    {
      text: "Created On",
      value: "createdAt",
      custom: true,
    },

    {
      text: "Amount",
      value: "amount",
      sortable: false,
      custom: true,
    },
    {
      text: "Status",
      value: "state",
      sortable: false,
      custom: true,
    },
  ]

  statistics: { [key: string]: any } | null | undefined = null

  get queries() {
    return [
      {
        query: InvoicesListQuery,
      },
    ]
  }

  gotoDetailPage(invoice: ConsultantInvoice) {
    this.$router.push({
      name: this.$routes.InvoiceDetail,
      params: { id: invoice.scatterId.toString() },
    })
  }

  onStatResult(result: FetchResult<FinanceStatisticsQueryQuery>) {
    this.statistics = result.data?.financeStatistics
  }
}
